import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { BlueBox, NoResults } from '../common'
import { Padding, ProgressChart } from '../../../..'

const Header = styled.div`
    font-size: 15px;
    height: 20%;
`

const Body = styled.div`
  align-items: flex-end;
  display: flex;
  height: 80%;
  justify-content: space-between;
  width 100%;
`

const ReturningNew = ({ isEmpty, loading, value, withLavels }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Header>
            <Padding fullHeight>Returning vs. New</Padding>
        </Header>
        <Body>
            {isEmpty && <NoResults />}
            {!isEmpty && <ProgressChart size="lg" value={value} labels={withLavels ? ['Returning', 'New'] : null} withPercentage withOpponent />}
        </Body>
    </BlueBox>
)

ReturningNew.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    value: PropTypes.number,
    withLavels: PropTypes.bool,
}

ReturningNew.defaultProps = {
    isEmpty: true,
    loading: null,
    value: 0,
    withLavels: true,
}

export default ReturningNew
